import Home from '../pages/Home';
import Services from '../pages/Services';
import ServiceDetail from '../pages/ServiceDetail';
import Locations from '../pages/Locations';
import LocationService from '../pages/LocationService';
import StateServiceDetail from '../pages/StateServiceDetail';
import AreaServiceDetail from '../pages/AreaServiceDetail';
import Brands from '../pages/Brands';
import BrandService from '../pages/BrandService';
import BrandServiceDetail from '../pages/BrandServiceDetail';
import BrandServiceLocation from '../pages/BrandServiceLocation';
import BookService from '../pages/BookService';
import PartnerWithUs from '../pages/PartnerWithUs';
import Blog from '../pages/Blog';
import BlogPost from '../pages/BlogPost';
import Disclaimer from '../pages/Disclaimer';
import ServiceCenter from '../pages/ServiceCenter';
import type { RouteConfig } from '../types/route';

export const publicRoutes: RouteConfig[] = [
  { path: '/', component: Home },
  { path: '/services', component: Services },
  { path: '/services/:service', component: ServiceDetail },
  { path: '/services/:service/service-center', component: ServiceCenter },
  { path: '/locations', component: Locations },
  { path: '/locations/:state', component: LocationService },
  { path: '/locations/:state/service/:service', component: StateServiceDetail },
  { path: '/locations/:state/:city', component: LocationService },
  { path: '/locations/:state/:city/:service', component: LocationService },
  { path: '/locations/:state/:city/area/:area', component: AreaServiceDetail },
  { path: '/locations/:state/:city/service-center/:service', component: ServiceCenter },
  { path: '/brands', component: Brands },
  { path: '/brands/:brand', component: BrandService },
  { path: '/brands/:brand/:service', component: BrandServiceDetail },
  { path: '/brands/:brand/:service/service-center', component: ServiceCenter },
  { path: '/brands/:brand/:service/:state', component: BrandServiceLocation },
  { path: '/brands/:brand/:service/:state/:city', component: BrandServiceLocation },
  { path: '/brands/:brand/:service/:state/:city/:area', component: BrandServiceLocation },
  { path: '/book', component: BookService },
  { path: '/partner', component: PartnerWithUs },
  { path: '/blog', component: Blog },
  { path: '/blog/:slug', component: BlogPost },
  { path: '/disclaimer', component: Disclaimer }
];